import { selectors as session } from '../session';
import { selectors as current } from '../current';
import { ITEM_KINDS, ITEM_STATUSES } from '../../constants/items';
import {
  getFeaturedProviderType,
  getAnalyticsProviderType,
} from '../../components/steps/home-services-app/app/utils';

export const searchHomeServicesOffers = state =>
  state.homeServices.searchHomeServicesOffers;

// deprecated for providerType
export const featuredProviderType = state => {
  if (!state.homeServices.propertyConfig) return null;

  const { providers = [] } = state.homeServices.propertyConfig;

  return getFeaturedProviderType(providers);
};

export const providerType = state => {
  if (!state.homeServices.propertyConfig) return null;

  const { providers = [] } = state.homeServices.propertyConfig;

  return getAnalyticsProviderType(providers);
};

export const getAppData = state => {
  const { id, toAddress, fromAddress } = current.move(state);
  const {
    email,
    uuid,
    firstName,
    lastName,
    cellPhone,
    homePhone,
    metadata,
    test,
  } = current.user(state);

  const siteConfig = current.siteConfig();
  const propertyName =
    siteConfig.divisionName(state) || siteConfig.companyName(state);
  const propertyType = siteConfig.channelDivisionName(state) || 'Property';

  const item = current.findItemByKind(ITEM_KINDS.HOME_SERVICES_APP, state);
  // TODO: If this is the first time we enter the step, the creation of the
  // move item is still in-flight and `item` will still be `undefined` locally.
  const status = item ? item.status(state) : ITEM_STATUSES.STARTED;
  const itemState = item?.state(state);

  return {
    move: {
      id: id(state),
      toAddress: toAddress(state),
      fromAddress: fromAddress(state),
    },
    company: siteConfig.company(state),
    sessionHeaders: {
      ...session.headers(state),
      app: 'mover',
    },
    // DEPRECATE: Use itemStatus instead since status is pretty generic
    status,
    itemStatus: status,
    itemState,
    propertyName,
    propertyType,
    user: {
      email: email(state),
      uuid: uuid(state),
      firstName: firstName(state),
      lastName: lastName(state),
      phone: cellPhone(state) || homePhone(state),
      metadata: metadata(state),
      test: test(state),
    },
  };
};
